import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function FDTreatments() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1126">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1127">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1128">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1129">
            FAT DISSOLVING TREATMENTS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1130"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1131">
          {/* BeSCULPTED Card */}
          <AnimateOnScroll data-id="element-1132">
            <div className="bg-white p-10 lg:p-12 shadow-[0_4px_20px_rgba(0,0,0,0.06)] border-t-[3px] border-[#FF1493] h-full" data-id="element-1133">
              <h3 className="text-[28px] font-bold font-[Poppins,_sans-serif] mb-6" data-id="element-1134">
                <span className="text-[#FF1493]" data-id="element-1135">Be</span>
                <span className="text-black" data-id="element-1136">SCULPTED</span>
              </h3>

              <p className="text-[#333333] text-[15px] leading-[1.7] font-body mb-8" data-id="element-1137">
                Be CLINICAL offers the BeSCULPTED treatment, a proprietary
                fat-dissolving injection designed to target and eliminate
                stubborn fat deposits resistant to diet and exercise. This
                non-surgical procedure involves administering a specialized
                formula directly into areas with unwanted fat, effectively
                breaking down fat cells and facilitating their natural
                elimination from the body.
              </p>

              <h4 className="text-black text-lg font-bold font-[Poppins,_sans-serif] mb-3" data-id="element-1138">
                Benefits
              </h4>
              <div className="w-[30px] h-[2px] bg-[#FF1493] mb-5" data-id="element-1139"></div>

              <ul className="space-y-3" data-id="element-1140">
                {['Customized treatment allowing for precise contouring and enhancement of body aesthetics', 'Addresses common areas where fat tends to persist like love handles, abdomen and thighs', 'Minimally invasive, with most individuals experiencing minimal downtime'].map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-1141">
                    <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1142" />
                    <span className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-1143">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </div>
          </AnimateOnScroll>

          {/* Kybella Card */}
          <AnimateOnScroll delay={150} data-id="element-1144">
            <div className="bg-white p-10 lg:p-12 shadow-[0_4px_20px_rgba(0,0,0,0.06)] border-t-[3px] border-[#FF1493] h-full" data-id="element-1145">
              <h3 className="text-[28px] font-bold font-[Poppins,_sans-serif] text-black mb-6" data-id="element-1146">
                Kybella
              </h3>

              <p className="text-[#333333] text-[15px] leading-[1.7] font-body mb-8" data-id="element-1147">
                Kybella is an FDA-approved, non-surgical injectable treatment
                designed to reduce submental fat, commonly known as a double
                chin. Its active ingredient, synthetic deoxycholic acid,
                naturally occurs in the body and aids in breaking down and
                absorbing dietary fat. When injected into the fat beneath the
                chin, Kybella destroys fat cells, resulting in a noticeable
                reduction of fullness under the chin and an improved facial
                profile.
              </p>

              <h4 className="text-black text-lg font-bold font-[Poppins,_sans-serif] mb-3" data-id="element-1148">
                Benefits
              </h4>
              <div className="w-[30px] h-[2px] bg-[#FF1493] mb-5" data-id="element-1149"></div>

              <ul className="space-y-3" data-id="element-1150">
                {['Non-invasive eliminating the need for incisions or anesthesia', 'Most patients can resume their regular activities shortly after treatment', 'Any swelling or bruising typically subsiding within a few days', 'Once the fat cells are destroyed, they cannot store or accumulate fat'].map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-1151">
                    <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1152" />
                    <span className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-1153">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}